import MultiQueryPageLoader from '@/common/components/MultiQueryPageLoader.tsx'
import AffiliationsTable from '@/pages/setup/provider_affiliations/_components/AffiliationsTable.tsx'
import { useProviderAffiliations } from '@/queries/providers/affiliations/hooks.ts'
import { AuthorizationError } from '@/app/common/components/AuthorizationError'
import { useUserPrivileges } from '@/hook/useUserPrivileges'

const ProviderAffiliationsPage = () => {
  const privileges = useUserPrivileges()
  const canReadAffiliations = privileges.user.provider_management_read

  const { query: affiliationsQuery, invalidateQuery } =
    useProviderAffiliations(canReadAffiliations)

  if (!canReadAffiliations) {
    return <AuthorizationError />
  }

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[affiliationsQuery] as const}
    >
      {([affiliations]) => (
        <AffiliationsTable
          affiliations={affiliations}
          onRefresh={invalidateQuery}
        />
      )}
    </MultiQueryPageLoader>
  )
}

export default ProviderAffiliationsPage
